import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LOGIN_BACKGROUND_IMG } from './utils/apiRoutes';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
  palette: {
    primary: blue,
  },
  typography: {
    useNextVariants: true,
  },
});

const getEnableV3Ui = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const raw = window.localStorage.getItem('EnableV3Ui');
    if (raw === null) return false;
    if (raw === 'true' || raw === '1') return true;
    if (raw === 'false' || raw === '0') return false;
    try { return JSON.parse(raw) === true; } catch (e) { return false; }
  } catch (e) {
    return false;
  }
};

const enableV3Ui = getEnableV3Ui();

class App extends Component {
  renderStyles() {
    const backgroundImage = `${LOGIN_BACKGROUND_IMG}`;

    const bgUrl =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '') +
      backgroundImage;
    const styles = {
      marginRight: '0px',
      marginTop: '0px',
      marginLeft: '0px',
      width: '100%',
      minHeight: '100%',
      backgroundColor: `${enableV3Ui ? '#007BC7' : '#344560'}`,
      backgroundImage: 'url(' + bgUrl + ')',
      WebkitBackgroundSize: 'cover',
      MozBackgroundSize: 'cover',
      OBackgroundSize: 'cover',
      backgroundSize: 'cover',
    };

    return styles;
  }

  render() {
    const main = this.renderStyles();
    
    return (
      <MuiThemeProvider theme={theme}>
        <div className="row center-xs middle-xs" style={main}>
          {this.props.children}
        </div>
      </MuiThemeProvider>
    );
  }
}

App.propTypes = {
  children: PropTypes.object,
};

export default connect()(App);
